import { httpRequest } from "../../http";
import { CatalogVertical, VerticalIn } from "@models/catalog.model";

const COLL = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/catalog/verticals/`;

export class CommandCreateVertical {
  async run(payload: VerticalIn): Promise<CatalogVertical> {
    return httpRequest<CatalogVertical>(COLL, { method: "POST", body: payload });
  }
}

export class CommandUpdateVertical {
  async run(id: number, payload: VerticalIn): Promise<CatalogVertical> {
    return httpRequest<CatalogVertical>(`${COLL}${id}/`, { method: "PUT", body: payload });
  }
}

export class CommandDeleteVertical {
  async run(id: number): Promise<void> {
    await httpRequest(`${COLL}${id}/`, { method: "DELETE" });
  }
}
